<template>
  <article>
    <NuxtPage />
  </article>
</template>

<style scoped>
article {
  padding: 1rem 2rem;
  border-radius: 1cqh;
  margin: 1rem auto 3rem;
  max-width: 90ch;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--color-slate-50);
  @media screen and (min-width: 768px) {
    padding: 1rem 4rem;
    margin-top: 6rem;
  }
}
</style>
